import React from "react";
import styled from "styled-components";

interface PropTypes {
  children: React.ReactNode;
  id: string;
}

let Container = styled.div`
  & input {
    caret-color: transparent;
    outline: none;
  }
`;

function WebCodeField(props: PropTypes) {
  return (
    <label for={props.id}>
      <Container>{props.children}</Container>
    </label>
  );
}

export default WebCodeField;
